import TopicList from "../views/TopicList";
import TopicDetails from "../views/TopicDetails";

export default [
    {
        path: "/topic-list",
        name: "TopicList",
        component: TopicList,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: "/topic-details",
        name: "TopicDetails",
        component: TopicDetails,
        meta: {
            requiresAuth: true
        }
    },
];
